module.exports = __webpack_public_path__ + "static/MICHAEL-ROSE2-ccaed6c21833d9f7dd422aaec738cf54.jpg";